import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-market-label",
  "use": "icon-market-label-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-market-label\"><defs><style type=\"text/css\"></style></defs><path d=\"M832 64H192c-70.4 0-128 57.6-128 128v640c0 70.4 57.6 128 128 128h640c70.4 0 128-57.6 128-128V192c0-70.4-57.6-128-128-128z m-32 447.8H320v320h-64v-640h544l-161.3 160 161.3 160z\" fill=\"\" p-id=\"33797\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol